import styled from 'styled-components';
import { Form } from 'antd';

export const FormWrapper = ({ children, ...rest }) => <PaddedForm {...rest}>{children}</PaddedForm>;

export const PaddedForm = styled(Form)`
  padding: 5px 20px;
`;
